import React from "react";
import { ROUTES } from "../routes";
import reports from "../assets/sidebaricons/reportsInactive.svg";
import reportsActive from "../assets/sidebaricons/reportsActive.svg";

// const ReportsIcon = (location) => {
//     const isActive = location.location === ROUTES.REPORTS || location.location === ROUTES.PILOTS_PERFORMANCE_REPORT
//     return (
//         <img
//             alt=''
//             className={isActive ? "sideBarIcon" : "sideBarIcon-not-selected"}
//             src={isActive ? reportsActive : reports}
//         />
//     )
// }
const ReportsIcon = (location) => {
  const isActive =
    location.location === ROUTES.REPORTS ||
    location.location === ROUTES.PILOTS_PERFORMANCE_REPORT;
  return (
    <img
      alt=""
      className={isActive ? "sideBarIcon" : "sideBarIcon-not-selected"}
      style={{
        width: "20px",
        height: "20px",
        minWidth: "20px",
        minHeight: "20px",
      }}
      src={isActive ? reportsActive : reports}
    />
  );
};

export default ReportsIcon;
